module.exports = __webpack_public_path__ + "img/excluCom.d4dbe9c1.svg";